import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { StateSnackBarService } from './state-snack-bar.service';

export interface MapFilters {
  minRating: number;

  // RestStopDetailsDto-Felder
  playground: boolean;
  restaurant: boolean;
  gasStation: boolean;
  kiosk: boolean;
  shower: boolean;
  wifi: boolean;
  picnicArea: boolean;
  chargingStation: boolean;
  atm: boolean;
  vendingMachine: boolean;
  isFee: boolean;
  price: number | null; // null = keine Preisfilterung
}

@Injectable({
  providedIn: 'root',
})
export class MapFilterService {
  private readonly initialFilters: MapFilters = {
    minRating: 0,

    playground: false,
    restaurant: false,
    gasStation: false,
    kiosk: false,
    shower: false,
    wifi: false,
    picnicArea: false,
    chargingStation: false,
    atm: false,
    vendingMachine: false,
    isFee: false,
    price: null,
  };

  private filtersSubject = new BehaviorSubject<MapFilters>(this.initialFilters);
  public filters$ = this.filtersSubject.asObservable();

  private stateSnackbarService = inject(StateSnackBarService);
  private authService = inject(AuthService);
  private http = inject(HttpClient);
  private apiUrl = environment.backend + '/filter';

  constructor() {
    this.authService.currentUser$.subscribe((user) => {
      if (user) {
        this.loadFiltersFromDatabase();
      } else {
        this.filtersSubject.next(this.initialFilters);
      }
    });
  }

  updateFilters(newFilters: Partial<MapFilters>): void {
    const currentFilters = this.filtersSubject.getValue();
    this.filtersSubject.next({ ...currentFilters, ...newFilters });

    if (this.authService.isLoggedIn()) {
      this.updateUserFilterInDatabase();
    }
  }

  resetFilters(): void {
    this.filtersSubject.next(this.initialFilters);
  }

  getCurrentFilters(): MapFilters {
    return this.filtersSubject.getValue();
  }

  private loadFiltersFromDatabase(): void {
    this.http.get<MapFilters>(`${this.apiUrl}`).subscribe({
      next: (savedFilters) => {
        if (savedFilters && Object.keys(savedFilters).length > 0) {
          const newState = { ...this.initialFilters, ...savedFilters };
          this.filtersSubject.next(newState);
        }
      },
      error: (err) =>
        this.stateSnackbarService.error({
          message: 'Gespeicherte Filter konnten nicht geladen werden:',
          subMessage: err.message,
        }),
    });
  }
  updateUserFilterInDatabase() {
    this.http.post(`${this.apiUrl}/update`, { filters: this.getCurrentFilters() }).subscribe();
  }
}
